import React from 'react';

const Page = () => {
    return <div className="login-container">
        Login
    </div>
}

export default Page;